import * as React from 'react';

function SvgCambiodetitularIcon(props) {
  return (
    <svg
      id="cambiodetitular_icon_svg"
      width={props.size || 149}
      height={props.size || 149}
      viewBox="7 4 91 91"
      xmlSpace="preserve"
      fill="#fff"
      {...props}
    >
      <defs>
        <linearGradient
          id="cambiodetitular_icon_svg__b"
          x1={-0.092}
          y1={-0.109}
          x2={1.087}
          y2={1.231}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#108dc7" />
          <stop offset={1} stopColor="#ef8e38" />
        </linearGradient>
        <filter
          id="cambiodetitular_icon_svg__a"
          x={0}
          y={0}
          width={108.689}
          height={108.689}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={2} dy={4} />
          <feGaussianBlur stdDeviation={3} result="blur" />
          <feFlood floodColor="#2a67e2" floodOpacity={0.349} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Grupo 711">
        <g filter="url(#cambiodetitular_icon_svg__a)">
          <path
            data-name="Trazado 373"
            d="M3.652 0h83.385a3.652 3.652 0 013.652 3.652v83.385a3.652 3.652 0 01-3.652 3.652H3.652A3.652 3.652 0 010 87.037V3.652A3.652 3.652 0 013.652 0z"
            transform="translate(7 5)"
            fill="url(#cambiodetitular_icon_svg__b)"
          />
        </g>
        <g data-name="Grupo 641">
          <path
            data-name="Trazado 653"
            d="M24.946 51.257a.946.946 0 01-.947-.947 5.689 5.689 0 015.683-5.683.947.947 0 010 1.894 3.793 3.793 0 00-3.786 3.789.946.946 0 01-.95.947z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 642">
          <path
            data-name="Trazado 654"
            d="M32.524 46.521h-2.842a.947.947 0 010-1.894h2.842a.947.947 0 010 1.894z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 643">
          <path
            data-name="Trazado 655"
            d="M24.946 55.047a.946.946 0 01-.947-.947v-3.79a.947.947 0 111.894 0v3.79a.946.946 0 01-.947.947z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 644">
          <path
            data-name="Trazado 656"
            d="M47.678 51.257a.946.946 0 01-.947-.947 3.793 3.793 0 00-3.789-3.789.947.947 0 010-1.894 5.689 5.689 0 015.683 5.683.946.946 0 01-.947.947z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 645">
          <path
            data-name="Trazado 657"
            d="M42.943 46.521h-2.842a.947.947 0 010-1.894h2.842a.947.947 0 010 1.894z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 646">
          <path
            data-name="Trazado 658"
            d="M47.678 55.047a.946.946 0 01-.947-.947v-3.79a.947.947 0 111.894 0v3.79a.946.946 0 01-.947.947z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 647">
          <path
            data-name="Trazado 659"
            d="M32.523 46.521a.947.947 0 01-.947-.947v-3.728a.947.947 0 111.894 0v3.728a.947.947 0 01-.947.947z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 648">
          <path
            data-name="Trazado 660"
            d="M40.101 46.521a.947.947 0 01-.947-.947v-3.728a.947.947 0 111.894 0v3.728a.947.947 0 01-.947.947z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 649">
          <path
            data-name="Trazado 661"
            d="M36.312 43.679a9.481 9.481 0 01-9.474-9.47.947.947 0 111.894 0 7.577 7.577 0 0015.155 0 .947.947 0 111.894 0 9.482 9.482 0 01-9.473 9.47z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 650">
          <path
            data-name="Trazado 662"
            d="M27.788 35.203a.947.947 0 01-.947-.947v-5.732a.947.947 0 011.894 0v5.731a.947.947 0 01-.947.948z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 651">
          <path
            data-name="Trazado 663"
            d="M44.837 35.156a.947.947 0 01-.947-.947v-5.685a.947.947 0 011.894 0v5.685a.947.947 0 01-.947.947z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 652">
          <path
            data-name="Trazado 664"
            d="M44.837 29.472a.947.947 0 01-.947-.947 2.845 2.845 0 00-2.842-2.842.947.947 0 010-1.894 4.741 4.741 0 014.736 4.736.947.947 0 01-.947.947z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 653">
          <path
            data-name="Trazado 665"
            d="M41.048 25.683a.947.947 0 01-.947-.947v-3.789a.947.947 0 011.894 0v3.789a.947.947 0 01-.947.947z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 654">
          <path
            data-name="Trazado 666"
            d="M41.048 21.894h-5.683a.947.947 0 110-1.894h5.683a.947.947 0 010 1.894z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 655">
          <path
            data-name="Trazado 667"
            d="M27.788 29.472a.947.947 0 01-.95-.947A8.534 8.534 0 0135.366 20a.947.947 0 110 1.894 6.638 6.638 0 00-6.628 6.631.947.947 0 01-.947.947z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 659">
          <g data-name="Grupo 656">
            <path
              data-name="Trazado 668"
              d="M44.836 32.337a.944.944 0 01-.529-.162l-2.842-1.918a.947.947 0 111.06-1.569l2.842 1.918a.946.946 0 01-.53 1.731z"
              fill="#fff"
            />
          </g>
          <g data-name="Grupo 657">
            <path
              data-name="Trazado 669"
              d="M36.786 31.366a22.653 22.653 0 01-6.455-1 .949.949 0 01.6-1.8 21.083 21.083 0 005.858.9 11.961 11.961 0 004.79-.841.948.948 0 01.841 1.7 13.522 13.522 0 01-5.634 1.041z"
              fill="#fff"
            />
          </g>
          <g data-name="Grupo 658">
            <path
              data-name="Trazado 670"
              d="M27.788 32.337a.946.946 0 01-.53-1.731l2.841-1.918a.947.947 0 111.06 1.569l-2.841 1.918a.944.944 0 01-.53.162z"
              fill="#fff"
            />
          </g>
        </g>
        <g data-name="Grupo 660">
          <path
            data-name="Trazado 671"
            d="M59.039 60.691a.945.945 0 01-.947-.947v-4.091a.947.947 0 111.894 0v4.091a.946.946 0 01-.947.947z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 661">
          <path
            data-name="Trazado 672"
            d="M76.088 60.729a.946.946 0 01-.947-.947v-4.264a.947.947 0 111.894 0v4.263a.946.946 0 01-.947.948z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 662">
          <path
            data-name="Trazado 673"
            d="M76.089 56.466a.945.945 0 01-.947-.947 8.051 8.051 0 00-16.1 0 .947.947 0 01-1.894 0 9.946 9.946 0 0119.891 0 .946.946 0 01-.95.947z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 663">
          <path
            data-name="Trazado 674"
            d="M76.09 57.887a.944.944 0 01-.753-.372c-2.331-3.043-3.378-2.731-6.178-1.894a22.745 22.745 0 01-11.211.83.947.947 0 11.3-1.871 21.07 21.07 0 0010.374-.779c2.966-.881 5.105-1.518 8.226 2.558a.946.946 0 01-.177 1.328.93.93 0 01-.581.2z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 664">
          <path
            data-name="Trazado 675"
            d="M71.372 55.071a.948.948 0 01-.781-1.482l2.822-4.13a.948.948 0 011.567 1.068l-2.823 4.131a.951.951 0 01-.785.413z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 665">
          <path
            data-name="Trazado 676"
            d="M56.197 76.83a.946.946 0 01-.947-.947 5.688 5.688 0 015.683-5.683.947.947 0 110 1.894 3.793 3.793 0 00-3.789 3.789.946.946 0 01-.947.947z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 666">
          <path
            data-name="Trazado 677"
            d="M63.775 72.094h-2.842a.947.947 0 010-1.894h2.842a.947.947 0 010 1.894z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 667">
          <path
            data-name="Trazado 678"
            d="M56.197 80.618a.945.945 0 01-.947-.947v-3.788a.947.947 0 111.894 0v3.788a.946.946 0 01-.947.947z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 668">
          <path
            data-name="Trazado 679"
            d="M78.93 76.83a.946.946 0 01-.947-.947 3.793 3.793 0 00-3.789-3.789.947.947 0 010-1.894 5.688 5.688 0 015.683 5.683.946.946 0 01-.947.947z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 669">
          <path
            data-name="Trazado 680"
            d="M74.194 72.094h-2.842a.947.947 0 010-1.894h2.842a.947.947 0 010 1.894z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 670">
          <path
            data-name="Trazado 681"
            d="M78.929 80.618a.945.945 0 01-.947-.947v-3.788a.947.947 0 111.894 0v3.788a.946.946 0 01-.947.947z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 671">
          <path
            data-name="Trazado 682"
            d="M63.775 72.094a.946.946 0 01-.947-.947v-3.728a.947.947 0 111.894 0v3.728a.946.946 0 01-.947.947z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 672">
          <path
            data-name="Trazado 683"
            d="M71.352 72.094a.946.946 0 01-.947-.947v-3.728a.947.947 0 111.894 0v3.728a.946.946 0 01-.947.947z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 673">
          <path
            data-name="Trazado 684"
            d="M67.563 69.253a9.48 9.48 0 01-9.471-9.47.947.947 0 011.894 0 7.577 7.577 0 0015.155 0 .947.947 0 011.894 0 9.481 9.481 0 01-9.472 9.47z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 674">
          <path
            data-name="Trazado 685"
            d="M67.564 73.99c-2.7 0-4.736-1.223-4.736-2.845a.947.947 0 111.894 0c0 .237 1.007.951 2.842.951s2.842-.714 2.842-.951a.947.947 0 111.894 0c0 1.623-2.036 2.845-4.736 2.845z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 677">
          <g data-name="Grupo 675">
            <path
              data-name="Trazado 686"
              d="M66.143 80.62a.946.946 0 01-.944-.947v-2.842a.947.947 0 111.894 0v2.842a.946.946 0 01-.95.947z"
              fill="#fff"
            />
          </g>
          <g data-name="Grupo 676">
            <path
              data-name="Trazado 687"
              d="M68.985 80.62a.946.946 0 01-.944-.947v-2.842a.947.947 0 111.894 0v2.842a.946.946 0 01-.95.947z"
              fill="#fff"
            />
          </g>
        </g>
        <g data-name="Grupo 678">
          <path
            data-name="Trazado 688"
            d="M36.312 48.42c-2.7 0-4.736-1.224-4.736-2.845a.947.947 0 011.894 0c0 .237 1.008.951 2.842.951s2.842-.714 2.842-.951a.947.947 0 011.894 0c0 1.621-2.036 2.845-4.736 2.845z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 679">
          <path
            data-name="Trazado 689"
            d="M36.312 55.049a.946.946 0 01-.947-.947V51.26a.947.947 0 011.894 0v2.842a.946.946 0 01-.947.947z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 680">
          <path
            data-name="Trazado 690"
            d="M67.564 43.68a.947.947 0 01-.947-.947V30.418a.947.947 0 011.894 0v12.314a.947.947 0 01-.947.948z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 681">
          <path
            data-name="Trazado 691"
            d="M67.564 31.365H48.625a.947.947 0 010-1.894h18.939a.947.947 0 110 1.894z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 682">
          <path
            data-name="Trazado 692"
            d="M50.519 33.259a.945.945 0 01-.67-.278l-1.893-1.893a.947.947 0 011.339-1.339l1.893 1.893a.947.947 0 01-.67 1.617z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 683">
          <path
            data-name="Trazado 693"
            d="M48.625 31.365a.947.947 0 01-.67-1.617l1.893-1.893a.947.947 0 111.339 1.339l-1.892 1.893a.945.945 0 01-.67.278z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 684">
          <path
            data-name="Trazado 694"
            d="M36.306 71.166a.946.946 0 01-.947-.947V57.898a.947.947 0 011.894 0v12.321a.948.948 0 01-.947.947z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 685">
          <path
            data-name="Trazado 695"
            d="M54.297 71.166H36.306a.947.947 0 010-1.894h17.991a.947.947 0 010 1.894z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 686">
          <path
            data-name="Trazado 696"
            d="M54.298 71.167a.945.945 0 01-.67-.278l-1.894-1.9a.947.947 0 011.339-1.331l1.892 1.892a.947.947 0 01-.67 1.617z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 687">
          <path
            data-name="Trazado 697"
            d="M52.403 73.061a.947.947 0 01-.67-1.617l1.895-1.892a.947.947 0 111.337 1.337l-1.894 1.894a.949.949 0 01-.668.278z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 688">
          <path
            data-name="Trazado 698"
            d="M78.929 80.618H56.197a.947.947 0 010-1.894h22.732a.947.947 0 010 1.894z"
            fill="#fff"
          />
        </g>
        <g data-name="Grupo 689">
          <path
            data-name="Trazado 699"
            d="M47.678 55.051H24.946a.95.95 0 010-1.9h22.732a.947.947 0 010 1.894z"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgCambiodetitularIcon;
